import React from 'react';
import { Dropdown as AntdDropdown, DropdownProps as AntdDropdownProps, ConfigProvider } from 'antd';
import { useTheme } from '../../theme/ThemeContext';

export interface DropdownProps extends AntdDropdownProps{}

const Dropdown: React.FC<DropdownProps> = (props) => {
    const theme = useTheme();
    return (
        <ConfigProvider theme={theme}>
            <AntdDropdown {...props} />
        </ConfigProvider>
    );
};

export default Dropdown;
